import { isNotAutomaticId } from '@atlassian/ui-modifications-core/utils';
import { isNotEmptyString } from '@atlassian/ui-modifications-public-api-utils/is-not-empty-string';

export type UserPickerPublicSetValue = null | string;

export const userPickerSetValueValidator = (value: unknown): value is UserPickerPublicSetValue =>
	// We should omit automatic id special value, so it won't be picked up by this field
	// It is only applicable to the assignee field
	value === null || (isNotEmptyString(value) && isNotAutomaticId(value));
